export enum ServerType {

    PleXop = "pleXop",
    Login = "login",
    Compliance = "compliance",
    TradingDemo = "tradingDemo",
    TradingReal = "tradingReal",
    Billing = "billing",
    Api = "api",
    CES = "ces"
}
